import { memo, useCallback } from 'react';
import { cn, Price } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import Link from '@UI/Link';
import { IconPrice } from './IconPrice';
import styles from './TariffPrice.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { TariffExampleData, TariffTabData } from '@Pages/PageExpressDesign/type';

interface TariffPriceProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  price?: TariffTabData['price'];
  onScrollToBlock?: (e: MouseEvent, anchorName: string, tariffId?: string) => void;
  tariffId: string;
  example: TariffExampleData;
}

const TariffPrice: FC<TariffPriceProps> = (props) => {
  const { className, price, onScrollToBlock, tariffId, example, ...restProps } = props;
  const { t } = useTranslation();

  const handleScroll = useCallback(
    (e: MouseEvent, id: string) => {
      if (onScrollToBlock) onScrollToBlock(e, 'express-design-first-application', id);
    },
    [onScrollToBlock],
  );

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {price ? (
        <Price className={styles.price} price={price.value} />
      ) : (
        <div className={styles.noPrice}>
          <IconPrice className={styles.icon} />
        </div>
      )}
      <Button
        className={styles.button}
        wide
        theme={price ? 'primary' : 'secondary'}
        onClick={(e) => handleScroll(e, tariffId)}
      >
        {t('send-request')}
      </Button>
      <Link className={styles.download} view='primary' underlined to={example.url} target='_blank'>
        {example.title}
      </Link>
    </div>
  );
};

export default memo(TariffPrice);
